import parse from 'html-react-parser'
import log from './logger'

export const parseNumberWithCommas = (inputText: string) => {
  return parseFloat(inputText.replace(/,/g, ''))
}
export const capitalize = (title: string) => {
  return title.replace(/\b\w/g, (char) => char.toUpperCase())
}
export const parseHtml = (html: string) => {
  try {
    return parse(html)
  } catch (error) {
    log.error(error)
  }

  return null
}

export const formatShortContext = (length: number, text: string) => {
  if (text) {
    var shortText = text.substring(0, length)
    return shortText
  }
  return ''
}
